import { render, staticRenderFns } from "./AddBloodDonation.vue?vue&type=template&id=7b88515e"
import script from "./AddBloodDonation.vue?vue&type=script&lang=js"
export * from "./AddBloodDonation.vue?vue&type=script&lang=js"
import style0 from "./AddBloodDonation.vue?vue&type=style&index=0&id=7b88515e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports